import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8369bb5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-mod-content-timeline-wrapper js-timeline-container-1" }
const _hoisted_2 = { class: "hd-mod-content-timeline js-timeline-window" }
const _hoisted_3 = { class: "hd-mod-content-timeline__container hd-container" }
const _hoisted_4 = { class: "hd-mod-content-timeline__window" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mod_timeline_content = _resolveComponent("mod-timeline-content")!
  const _component_mod_timeline_indicator = _resolveComponent("mod-timeline-indicator")!
  const _component_mod_timeline_frames = _resolveComponent("mod-timeline-frames")!
  const _component_mod_content_timeline_loader = _resolveComponent("mod-content-timeline-loader")!
  const _component_mod_frame_target = _resolveComponent("mod-frame-target")!
  const _component_mod_stopwatch = _resolveComponent("mod-stopwatch")!
  const _component_mod_header = _resolveComponent("mod-header")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_mod_timeline_content, {
      datum: _ctx.datum,
      ready: !_ctx.loader
    }, null, 8, ["datum", "ready"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_mod_timeline_indicator, {
          sections: _ctx.sections,
          datum: _ctx.datum,
          ready: !_ctx.loader
        }, null, 8, ["sections", "datum", "ready"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_mod_timeline_frames, {
            datum: _ctx.datum,
            ready: !_ctx.loader
          }, null, 8, ["datum", "ready"])
        ])
      ]),
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          (_ctx.loader)
            ? (_openBlock(), _createBlock(_component_mod_content_timeline_loader, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_mod_frame_target, { datum: _ctx.datum }, null, 8, ["datum"]),
    _createVNode(_component_mod_stopwatch, { datum: _ctx.datum }, null, 8, ["datum"]),
    _createVNode(_component_mod_header, {
      datum: _ctx.datum,
      ready: !_ctx.loader
    }, null, 8, ["datum", "ready"])
  ]))
}